(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("point-cloud-hybrid-coloring", [], factory);
	else if(typeof exports === 'object')
		exports["point-cloud-hybrid-coloring"] = factory();
	else
		root["point-cloud-hybrid-coloring"] = factory();
})(self, function() {
return 